// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8992) return "static/chunks/8992-30f6f5393d7c072a.js";
	if (chunkId === 5947) return "static/chunks/5947-327b3d1f65cf8d90.js";
	if (chunkId === 4105) return "static/chunks/4105-f813e04e8aea627c.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"230":"a71e6cf847c5e9ab","1048":"bcdf93f90a5e7aea","2332":"ceda64a51a33aae3","2693":"ce1ed5e0b930bd9b","3554":"055b65f48b1502a9","5259":"f330a8e25ccf5507","6740":"052e34fa36c243f3","7425":"498d10b85cf1e5bc","8053":"0366824fa99c4e14"}[chunkId] + ".js";
};